import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Login from './Login'
import {login} from '../user/actions'

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleOnSubmit:(e, data)=>{
      e.preventDefault()
      return dispatch(login(data))
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    query: ownProps.location.search,
    isFetching: state.models.user.isFetching,
    loginErrorMessage: state.models.user.loginErrorMessage,
    ...ownProps
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/user/LoginPage.js